import { ChatEngine } from "react-chat-engine"
import ChatFeed from "./components/ChatFeed"
import LoginForm from "./components/LoginForm"
import "./App.css"

function App(){
  if(!localStorage.getItem('username')) return <LoginForm />
  return (
    <ChatEngine
      height = "100vh"
      projectID = "8f4cb02a-64df-44c6-8386-8b0a10f1378c"
      userName = {localStorage.getItem('username')}  //AkM
      userSecret = {localStorage.getItem('password')} //akhil123
      renderChatFeed = {(chatAppProps) => <ChatFeed {...chatAppProps} />}
    />
  )
}


export default App
